import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import isUrl from 'is-url';
import { Browser } from '@capacitor/browser';

import { useConfig } from 'Context/ConfigContext';
import { USER_PROFILE_LOGOUT } from 'Redux/user-profile/actions';
import { nsUnregisterFcmToken } from 'GraphQL/mutation/FCMToken.mutation';
import { FCMPlugin } from 'Util/Capacitors/SkooldioCapacitor';

import { getStoreApolloClient } from '../../../GraphQL';

import { MENU_LIST, MENU_KEY } from './constant';

const useSidebarMenu = (additionalItems = []) => {
  const { sidebarLinks = [], native } = useConfig();
  const { replace } = useHistory();
  const dispatch = useDispatch();

  const { enablePushNotification, enablePersonalizedNotification } = native ?? {};

  let _menuList = [];

  _menuList = [...sidebarLinks, ...additionalItems]
    .map((link) => {
      const { url, openInApp = true } = link;
      const menuProps = MENU_LIST[link.key] ?? null;

      if (!url) return menuProps;

      if (link.key === MENU_KEY.LOGOUT) {
        return {
          ...menuProps,
          onClick: async () => {
            if (enablePushNotification && enablePersonalizedNotification) {
              try {
                const { token } = await FCMPlugin.getToken();
                const storeApolloClient = getStoreApolloClient();
                await storeApolloClient.mutate({
                  mutation: nsUnregisterFcmToken,
                  variables: { token },
                });
              } catch (error) {
                console.error('FCMToken unregistration Error: ', error);
              }
            }
            dispatch({ type: USER_PROFILE_LOGOUT });
          },
        };
      }

      if (isUrl(url)) {
        return {
          ...menuProps,
          onClick: async () => {
            if (openInApp) {
              window.location.href = url;
            } else if (window.electron?.isElectron) {
              window.electron.openBrowser(url);
            } else {
              await Browser.open({ url });
            }
          },
        };
      } else {
        return { ...menuProps, onClick: () => replace(url) };
      }
    })
    .filter((e) => !!e);

  return _menuList;
};

export default useSidebarMenu;
